import React, { useState, useEffect } from 'react';
import { messagesAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Notifications.css';

const NOTIF_ICONS = {
  job_application: '📋',
  application_status: '✅',
  new_message: '💬',
  service_order: '🛒',
  review: '⭐',
  system: '🔔',
};

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const res = await messagesAPI.getNotifications();
      setNotifications(res.data.data || []);
    } catch {
      toast.error('فشل تحميل الإشعارات');
    } finally {
      setLoading(false);
    }
  };

  const markAllRead = async () => {
    try {
      await messagesAPI.markAllRead();
      setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
      toast.success('تم تحديد الكل كمقروء');
    } catch { toast.error('فشل التحديث'); }
  };

  const unreadCount = notifications.filter(n => !n.is_read).length;

  if (loading) return <div className="page-loading"><div className="spinner"></div></div>;

  return (
    <div className="notifications-page">
      <div className="notif-header">
        <div className="notif-header-content">
          <div>
            <h1>الإشعارات</h1>
            {unreadCount > 0 && <span className="unread-count">{unreadCount} غير مقروء</span>}
          </div>
          {unreadCount > 0 && (
            <button className="btn btn-outline btn-sm" onClick={markAllRead}>
              تحديد الكل كمقروء
            </button>
          )}
        </div>
      </div>

      <div className="notif-container">
        {notifications.length === 0 ? (
          <div className="empty-notifs">
            <span>🔔</span>
            <h3>لا توجد إشعارات</h3>
            <p>ستظهر هنا أحدث التنبيهات والتحديثات</p>
          </div>
        ) : (
          <div className="notif-list">
            {notifications.map(notif => (
              <div key={notif.id} className={`notif-item ${!notif.is_read ? 'unread' : ''}`}>
                <div className="notif-icon-wrap">
                  <span className="notif-icon">{NOTIF_ICONS[notif.type] || '🔔'}</span>
                </div>
                <div className="notif-body">
                  <p className="notif-title">{notif.title}</p>
                  <p className="notif-text">{notif.message}</p>
                  <span className="notif-time">
                    {new Date(notif.created_at).toLocaleString('ar', { dateStyle: 'medium', timeStyle: 'short' })}
                  </span>
                </div>
                {!notif.is_read && <div className="unread-dot" />}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
